/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { baseComponentManager } from '../../registry/Components';
import { ComponentManagerFn } from '../../registry/Component.type';
import { ItemType } from '../../registry/ComponentRegistry';
import { defaultValue } from './FunctionEditor';

const FunctionEditorManager: ComponentManagerFn<'FunctionEditor'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'FunctionEditor'>(platform, 'FunctionEditor'),
    type: 'FunctionEditor',
    name: 'Function Editor',
    isChildAllowed: (page, item, childType) =>
      ([] as ItemType[]).includes(childType),
    defaultValue,
    props: {
      functionUri: {
        label: 'Function URI',
        type: 'expression',
        returnType: async () => 'string',
      },
      defaultFunction: {
        label: 'Default Function',
        type: 'typescript',
        compileOnChange: true,
        defaultScript: `function myFunction() {
  return 'Hello World!';
}

export { myFunction };`,
      },
    },
    getDisplayText: (item) =>
      item.props.functionUri?.value ?? 'Choose a Function!',
    category: 'Forms',
    icon: { iconName: 'code' },
    description: 'Use this component to add a function editor.',
  };
};

export default FunctionEditorManager;
